
export function range(x, y) {
    return Array.from({ length: Math.abs(y - x) + 1 }, (_, i) => x < y ? x + i : x - i)
}